<template>
  <div id="app">
    <router-view></router-view>
    <footer>
    <cookie-law theme="dark-lime"></cookie-law>
  </footer>
  </div>
</template>

<script>
  import CookieLaw from 'vue-cookie-law'
  export default {
    components: { CookieLaw },
    name: 'App',
    data () {
      return {
        section: 'Head'
      }
    },
    methods: {}
  }
</script>



// WEBPACK FOOTER //
// App.vue?c63f8a54